module.exports = __webpack_public_path__ + "static/image/lesson_path_3.svg?e121e04f0a8a0b611aecbcd4cf573912";